export const formatAmount = (amount, currency) => {
  const numericAmount = Number(amount);
  const safeAmount = Number.isFinite(numericAmount) ? numericAmount : 0;
  let num = safeAmount.toFixed(2);
  const options = {
      style: 'decimal', minimumFractionDigits: 2,
      maximumFractionDigits: 2, useGrouping: true
  };

  if (currency == 'INR') {
    amount = new Intl.NumberFormat('en-IN', options).format(num);
  } else {
    amount = new Intl.NumberFormat('en-US', options).format(num);
  }

  const code = currency && currency.length ? currency.toUpperCase() : 'USD';
  return `${code} ${amount}`;
}

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});

  return `${parts.year}${parts.month}${parts.day} ${parts.hour}:${parts.minute} EST`;
}
